import { keepPreviousData } from '@tanstack/react-query'
import type { ResponseOf } from '@tuyau/core/types'
import type { routes } from 'gozoki-backend/registry'

export type CollaboratorListItem = ResponseOf<(typeof routes)['collaborators.get_all']>[number]

// La liste collaborateurs est lourde et partagée par tous les écrans RH : on garde le cache 5 min
// et on affiche la donnée précédente le temps du refetch pour éviter le flash vide au changement
// de boutique ou d'onglet.
export const collaboratorsQueryOptions = {
  placeholderData: keepPreviousData,
  staleTime: 1000 * 60 * 5,
}

type CollaboratorIdentity = Pick<CollaboratorListItem, 'id' | 'admin'>

/** Repli d'un collaborateur sans nom lisible (droits RH du lecteur, fiche absente de la liste). */
export const unnamedCollaborator = (id: number) => `Collaborateur #${id}`

/** Identité à plat (référent d'un hub, personnel rattaché) : `null` sans droit RH de lecture. */
interface PersonIdentity {
  id: number
  firstName?: string | null
  lastName?: string | null
}

/** Prénom et nom, ou « Collaborateur #12 » quand les droits RH du lecteur ne les donnent pas. */
export const personName = ({ id, firstName, lastName }: PersonIdentity) =>
  [firstName, lastName].filter(Boolean).join(' ').trim() || unnamedCollaborator(id)

/** `personName` d'un collaborateur de la liste RH (prénom et nom sous `admin`). */
export const collaboratorName = ({ id, admin }: CollaboratorIdentity) =>
  personName({ id, firstName: admin?.firstName, lastName: admin?.lastName })

/** Nom suivi du matricule quand il est lisible : « Saad AMJAD (MAT-042) ». */
export const collaboratorLabel = (
  collaborator: CollaboratorIdentity & Pick<CollaboratorListItem, 'matricule'>,
) => {
  const name = collaboratorName(collaborator)
  return collaborator.matricule === undefined ? name : `${name} (${collaborator.matricule})`
}
